<ng-container *ngIf="tooth$ | async as tooth">
  <mat-menu class="pr-right-click-menu">
    <ng-template matMenuContent>
      <div cdkFocusInitial></div>
      <button
        mat-menu-item
        [matMenuTriggerFor]="rootsMenu"
        [disabled]="disabled$ | async"
      >
        Update Roots
      </button>
      <mat-divider />

      @if (missingSurfaceChartedItems$ | async; as chartedItems) {
        @if (chartedItems.length) {
          <button
            mat-menu-item
            [matMenuTriggerFor]="missingSurfaceChartedItemsMenu"
          >
            Fix Missing Sufaces
          </button>

          <mat-menu
            #missingSurfaceChartedItemsMenu="matMenu"
            class="pr-right-click-menu"
          >
            <ng-template matMenuContent>
              @for (
                chartedItem of chartedItems;
                track chartedItem.config.ref.path
              ) {
                <button
                  mat-menu-item
                  (click)="fixMissingChartedItemSurfaces(chartedItem)"
                >
                  @if (chartedItem.config.display.icon.slug) {
                    <mat-icon
                      class="item-icon"
                      [ngStyle]="{
                        color: chartedItem.config.display.colour.value
                      }"
                      [svgIcon]="chartedItem.config.display.icon.slug"
                    />
                  }
                  <span>{{ chartedItem.config.name }}</span>
                </button>
              }
            </ng-template>
          </mat-menu>
        }
      }

      @if (chartedItems$ | async; as chartedItems) {
        <button
          mat-menu-item
          [matMenuTriggerFor]="chartedItemsMenu"
          [disabled]="!chartedItems.length || (disabled$ | async)"
        >
          Remove Charted Item
        </button>

        <mat-menu #chartedItemsMenu="matMenu" class="pr-right-click-menu">
          <ng-template matMenuContent>
            @for (
              chartedItem of chartedItems;
              track chartedItem.config.ref.path
            ) {
              <button mat-menu-item (click)="removeChartedItem(chartedItem)">
                @if (chartedItem.config.display.icon.slug) {
                  <mat-icon
                    class="item-icon"
                    [ngStyle]="{
                      color: chartedItem.config.display.colour.value
                    }"
                    [svgIcon]="chartedItem.config.display.icon.slug"
                  />
                }
                <span>{{ chartedItem.config.name }}</span>
              </button>
            }
          </ng-template>
        </mat-menu>
      }

      <mat-divider />
      <button
        mat-menu-item
        [disabled]="disabled$ | async"
        (click)="removeTooth(tooth)"
      >
        Remove Tooth
      </button>
    </ng-template>
  </mat-menu>

  <mat-menu #rootsMenu="matMenu" class="pr-right-click-menu">
    <ng-template matMenuContent>
      <button
        *ngFor="let roots of rootOptions; trackBy: trackByRoot"
        mat-menu-item
        [disabled]="tooth.roots === roots"
        (click)="changeRoots(roots, tooth)"
      >
        {{ roots }}
      </button>
    </ng-template>
  </mat-menu>
</ng-container>
